import api from './api';

// Auth service for client login
export const authService = {
  // Client login with tenant code
  login: async (credentials) => {
    const response = await api.post('/auth/client/login', {
      tenantCode: credentials.tenantCode,
      email: credentials.email,
      password: credentials.password,
      userType: 'CLIENT'
    });
    return response.data;
  },

  // Get user profile
  getProfile: async () => {
    const response = await api.get('/auth/profile');
    return response.data;
  },

  // Logout - calls backend API so cookies are cleared on server side
  logout: async () => {
    try {
      await api.post('/auth/logout');
    } catch (error) {
      console.error('API logout failed:', error);
    } finally {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('tenant');
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('user');
      sessionStorage.removeItem('tenant');
    }
  },

  // Check if user is authenticated
  isAuthenticated: () => {
    return !!localStorage.getItem('user');
  },

  // Get current user
  getCurrentUser: () => {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },

  // Get current tenant
  getCurrentTenant: () => {
    const tenant = localStorage.getItem('tenant');
    return tenant ? JSON.parse(tenant) : null;
  }
};

export default authService;